(function ($) {
    "use strict";
    $(function () {

        $('.js-open-detail-map').on('click', function (e) {
            e.preventDefault();
            $('.js-detail-map').slideDown();
            $('.js-detail-map').get(0).scrollIntoView({ behavior: "smooth" });
        })



        $('.js-close-detail-map').on('click', function (e) {
            e.preventDefault();
            $('.js-detail-map').slideUp();
            $('.js-location-wrapper').get(0).scrollIntoView({ behavior: "smooth" });

        })

        $('.js-show-more-text').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('active');
            var parentWrapper = $(this).parents('.js-residential-details-slider-with-extra');
            parentWrapper.find('.js-more-text').addClass('active');
        })


        $('.js-show-more-text-back').on('click', function (e) {
            e.preventDefault();
            var parentWrapper = $(this).parents('.js-more-text');
            parentWrapper.removeClass('active');
            parentWrapper.parent().find('.js-show-more-text').removeClass('active');
        })

        $('.js-open-offer-card').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            $(this).parent().find('.js-offer-card').slideToggle();
        })

        $(document).on('click', '.js-open-table-cols', function (e) {
            e.preventDefault();
            $(this).toggleClass('active');
            var tableCols = $(this).parent().find('.js-table-cols');
            tableCols.css('display', tableCols.css('display') === 'none' ? 'flex' : 'none');
        });


        let data;

        const url = new URL(window.location.href);
        const keys = Array.from(url.searchParams.keys());

        let token;
        if (keys.length > 0) {
            token = keys[0];
        }


        if (token != undefined) {
            $('.js-card-link').each(function () {
                var href = $(this).attr('href');
                var baseUrl = href.split('#');
                href = baseUrl[0];
                href += `?${token}`;
                if (baseUrl[1] != undefined) {
                    href += `#${baseUrl[1]}`;
                }

                $(this).attr('href', href);
            });
        }

        function isValidToken() {

            if (!token) {
                return Promise.resolve(false);  // Return a resolved promise with value 'false'
            }

            return new Promise((resolve, reject) => {
                cordiaAPI
                    .post("/sf/validatetoken", null, {
                        params: {
                            token: token,
                        },
                    })
                    .then(function (response) {
                        if (response.data.valid === true) {
                            data = response.data;
                            resolve(true);  // Resolve the promise with value 'true'
                        } else {
                            resolve(false); // Resolve the promise with value 'false'
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        reject(error);  // Reject the promise with the error
                    });
            });
        }


        function generateShortHash(str) {
            var hash = 0;
            for (var i = 0; i < str.length; i++) {
                var char = str.charCodeAt(i);
                hash = ((hash << 5) - hash) + char;
                hash = hash & hash; // Convert to 32bit integer
            }
            return Math.abs(hash);
        }

        function isValidUrl(string) {
            try {
                new URL(string);
                return true;
            } catch (_) {
                return false;
            }
        }


        function generateTable() {
            var jsonData = data.offers_json;

            // Get a reference to the table body
            var tableBody = $('.offer__table');

            // Generate and prepend table header
            generateHeader(jsonData[0], tableBody);

            var hasIframe = false;
            // Loop through the JSON data and create table rows
            jsonData.forEach(function (item, index) {
                var tableRow = $('<div class="table__row"></div>');

                // Loop through the keys (table headers) in the JSON object
                var index = 0;
                for (var key in item) {
                    if (item.hasOwnProperty(key)) {
                        var tableColClass = index == 0 ? 'js-open-table-cols' : 'js-table-cols';
                        var tableCol = $('<div class="table__col ' + tableColClass + '"></div>');
                        var label = key === "Ingatlan azonosító" ? '<p>Ingatlan</p>' : '<p>' + key + '</p>';
                        var value = item[key] !== null ? item[key] : '-';  // Check for null and replace with '-'

                        if (value !== '-') {
                            // Regular expression to check if it is a valid URL
                            var urlPattern = new RegExp('^(https?:\\/\\/)?(([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)*[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3})(\\:\\d+)?(\\/-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$', 'i');

                            if (isValidUrl(value)) {
                                // Check if the URL ends with an image file extension
                                var imagePattern = /\.(jpeg|jpg|gif|png)$/;
                                if (imagePattern.test(value)) {
                                    // It's an image URL, create a link
                                    value = '<a data-fancybox="" href="' + value + '">link</a>';
                                } else {

                                    if (value.includes("download")) {
                                        value = `
                                        <a href="${value}" download>
                                        link
                                        </a>
                                        `;
                                    } else {
                                        var hash = generateShortHash(value);
                                        hasIframe = true;
                                        value = `
                                        <a href="#" class="iframe-preview" data-izimodal-open="#${hash}">
                                        link
                                        </a>
    
                                        <div id="${hash}" class="iziModal iframe-modal" data-izimodal-transitionin="fadeInDown" data-izimodal-title="Marina City" data-izimodal-iframeURL="${value}"></div>
                                        `;
                                    }

                                }
                            } else {


                                value = value;
                            }
                        }

                        tableCol.html(label + value);
                        tableRow.append(tableCol);
                        index++;
                    }

                }

                // Append the row to the table body
                tableBody.append(tableRow);
            });

            if (hasIframe) {
                $(".iframe-modal").iziModal({
                    history: false,
                    iframe: true,
                    fullscreen: false,
                    headerColor: "#000000",
                    openFullscreen: true,
                    focusInput: false,
                    appendTo: ".modals-wrapper",
                    bodyOverflow: false,
                    onOpening: function () {
                        $(".iframe-modal").find("iframe").attr("allowfullscreen", "allowfullscreen");
                    },
                });
            }

        }

        function generateHeader(item, tableBody) {
            var header = $('<div class="table__header"></div>');

            for (var key in item) {
                if (item.hasOwnProperty(key)) {
                    var col = $('<div class="table__col">' + key + '</div>');
                    header.append(col);
                }
            }

            // Prepend the header to the table body
            tableBody.prepend(header);
        }


        function toggleHeadlineWrappers() {
            var headlineWrapper = $('.js-headline-wrapper');
            var headlineWrapperMod = $('.js-headline-wrapper-mod');
            var serviceCards = $('.js-service-cards-default');
            var offerCards = $('.js-service-cards-offers');


            isValidToken().then(isValid => {
                if (isValid) {
                    if (headlineWrapper.length) {
                        headlineWrapper.hide().remove();
                    }

                    if (headlineWrapperMod.length) {
                        headlineWrapperMod.html(headlineWrapperMod.html().replace('{lastname}', data.last_name).replace('{firstname}', data.first_name));
                        headlineWrapperMod.show();
                    }


                    //serviceCards.hide().remove();
                    if (offerCards.length) {
                        offerCards.parent().addClass('service__cards--mod')
                        offerCards.show();
                    }

                    generateTable();
                } else {
                    if (headlineWrapper) {
                        headlineWrapper.show();
                    }

                    if (headlineWrapperMod) {
                        headlineWrapperMod.hide().remove();
                    }

                    //serviceCards.show();
                    offerCards.hide().remove();
                    $('.js-offer-table').remove();
                }
            }).catch(error => {
                console.log('Error while validating token:', error);
            });



        }


        toggleHeadlineWrappers();


        $('.js-request-callback').on('click', function (e) {
            e.preventDefault();


            if (!token) {
                return false;
            }

            cordiaAPI
                .post("/sf/requestcallback", null, {
                    params: {
                        token: token,
                    },
                })
                .then(function (response) {
                    if (response.data.success === true) {


                        $(".js-request-callback-modal").iziModal({
                            width: 625,
                            radius: 0,
                            history: false,
                            arrowKeys: false,
                            navigateCaption: false,
                            navigateArrows: false,
                            focusInput: false,
                            autoOpen: true,
                        });

                    } else {
                        $.showError(response.data.error);
                    }
                })
                .catch(function (error) {
                    console.log(error);

                });

        });


    });
})(jQuery);
